import type { QuickFilter } from "../components/SolicitudesStats";
import { filtrosNoVacios, type SolicitudFiltros, type SolicitudSort } from "./ordenar-solicitudes";
import { paramsFiltrosFactura, type FiltrosFactura } from "./filtros-factura";

/** Tamaño de página del listado (convención P42) · compartido por la página y el loader. */
export const PAGE_SIZE_SOLICITUDES = 15;

export interface EstadoListadoSolicitudes {
  filtros: SolicitudFiltros;
  sort: SolicitudSort | null;
  quickFilter: QuickFilter;
  categoria?: string;
  incluirCanceladasYBajas: boolean;
  page: number;
  /** Fila de filtros por FACTURA (UUID, serie-folio, emisor, fecha de timbrado, total). */
  filtrosFactura?: FiltrosFactura;
}

/**
 * Params del servidor de «Mis solicitudes» · ÚNICA fuente para la página y el
 * loader de la ruta: si divergen, la precarga se hace con otra queryKey y la
 * primera visita vuelve a mostrar el skeleton.
 */
export function paramsMisSolicitudes(e: EstadoListadoSolicitudes): Record<string, string | number | boolean> {
  return {
    ...filtrosNoVacios(e.filtros),
    ...(e.sort ? { sortKey: e.sort.key, sortDir: e.sort.dir } : {}),
    ...(e.quickFilter ? { quickFilter: e.quickFilter } : {}),
    ...(e.categoria ? { categoria: e.categoria } : {}),
    ...paramsFiltrosFactura(e.filtrosFactura),
    incluirCanceladasYBajas: e.incluirCanceladasYBajas,
    page: e.page,
    pageSize: PAGE_SIZE_SOLICITUDES,
  };
}

/** Params de la PRIMERA página según los deep-links de la ruta (`?filtro`, `?categoria`, `?incluir`). */
export function paramsInicialesMisSolicitudes(search: {
  filtro?: Exclude<QuickFilter, null>;
  categoria?: string;
  incluir?: boolean;
}): Record<string, string | number | boolean> {
  return paramsMisSolicitudes({
    filtros: {},
    sort: null,
    quickFilter: search.filtro ?? null,
    categoria: search.categoria,
    incluirCanceladasYBajas: search.incluir ?? false,
    page: 1,
  });
}
